import { Component, computed, input, output, signal, viewChild, viewChildren } from '@angular/core';
import { RidButton } from '../../components/rid-button/rid-button';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidOption, TOption } from '../../components/rid-option/rid-option';
import { RidOverlayFeedback } from '../../components/rid-overlay-feedback/rid-overlay-feedback';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';
import { RidSfxDirective } from '../../directives/rid-sfx.directive';
import { AudioEffectPlayer } from '../../utils/audio.utils';

@Component({
  selector: 'rid-categorise-yes-no',
  imports: [
    RidMechanicBackground,
    RidMechanicWrapper,
    RidTopBar,
    RidMechanicContent,
    RidMechanicTitle,
    RidButton,
    RidOverlayFeedback,
    RidOption,
    RidSfxDirective,
  ],
  templateUrl: './rid-categorise-yes-no.html',
  host: {
    class: 'block',
  },
})
export class RidCategoriseYesNo {
  questions = input.required<
    {
      id: string;
      question: string;
      options: TOption[];
      answer: 'YES' | 'NO';
    }[]
  >();

  overlayFeedback = viewChild.required<RidOverlayFeedback>('overlayFeedback');
  options = viewChildren<RidOption>('options');

  isChecking = signal<undefined | 'YES' | 'NO'>(undefined);
  index = signal(0);
  progress = signal(0);
  question = computed(() => this.questions()[this.index()]);

  finished = output<void>();

  async presentItems() {
    const options = this.options();
    if (options.length === 1) {
      await options[0].present();
    }
  }

  async check(answer: 'YES' | 'NO') {
    this.isChecking.set(answer);

    if (answer === this.question().answer) {
      const isLastIndex = this.index() === this.questions().length - 1;

      if (isLastIndex) this.progress.set(this.progress() + 1);

      AudioEffectPlayer.play('CORRECT');
      await this.overlayFeedback().showCorrect();

      if (isLastIndex) {
        this.finished.emit();
      } else {
        this.progress.set(this.progress() + 1);
        this.index.set(this.index() + 1);
      }
    } else {
      AudioEffectPlayer.play('INCORRECT');
      await this.overlayFeedback().showIncorrect();
    }
    this.isChecking.set(undefined);
  }
}
